import Menu from './Menu';
import SubMenu from './SubMenu';
import MenuItem from './MenuItem';
import MenuItemGroup from './MenuItemGroup';
import Divider from './Divider';

export { SubMenu, MenuItem as Item, MenuItem, MenuItemGroup, MenuItemGroup as ItemGroup, Divider };

export default Menu;



// WEBPACK FOOTER //
// ../src4js/pc4public/portal/_rc/_rc-menu-7.0.3/src/index.js